import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import classnames from 'classnames';
import {Record} from 'immutable';
import numeral from 'numeral';
import LocalStorageMixin from 'react-localstorage';
import * as actions from '../actions';
import {default as PasteOrDropzone, SVG, PASTE, DROPZONE} from './PasteOrDropzone';
import ImageFormMixin from '../mixins/ImageFormMixin';
import OptimizedForSelect from './OptimizedForSelect';
import HelpUploadingIcons from './HelpUploadingIcons';
import {Request, POST} from 'requests';
import {default as RequestsMixin, HAS_ERRORS, HAS_FAILED, IS_DONE, IS_NOT_ALLOWED} from 'requests/RequestsMixin';
import DirectToCloudDropzone from './DirectToCloudDropzone';

const NewWorkingSetImage = Record({
  name: null,
  uploadedUrl: null,
});

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const UploadImageForm = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [ImageFormMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      uploadFailed: false,
    };
  },

  uploadRecord() {
    return NewWorkingSetImage({
      name: this.state.name,
      uploadedUrl: this.state.imageUrl,
    });
  },

  handleUploadClicked() {
    const record = this.uploadRecord();
    const request = new Request({
      url: ['api', 'kits', this.props.kitToken, 'working-set-images'],
      method: POST,
      record,
    });

    this.setState({
      uploading: true,
    });

    this.setRequest({
      uploadImage: request,
    }, {skipDispatch: true});

    this.props.dispatch(
      actions.createImageFromDropzone(request, record, this.state.dropzone)
    );
  },

  transitions(register) {
    register({
      request: this.requests.uploadImage,
      to: IS_DONE,
      call(rm) {
        this.props.onSuccess();
      },
    });

    register({
      request: this.requests.uploadImage,
      to: HAS_ERRORS,
      call(rm) {
        this.setState({uploading: false});
      },
    });

    register({
      request: this.requests.uploadImage,
      to: HAS_FAILED,
      call(rm) {
        this.setState({
          uploading: false,
          uploadFailed: true,
        });
      },
    });
  },

  render() {
    const rm = this.resourceManager();
    const stopDnD = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const uploadFailedElement = (this.state.uploadFailed) ?
      (
        <div id="build-error" className="alert alert-danger bg-body has-icon" role="alert">
          <i className="ficon ficon-warning alert-icon text-lg"></i>
          <p className="m-xs-b-0"><strong>Oops!</strong> There was an issue uploading your image. Try again.</p>
        </div>
      ) : null;

    return (
      <div className="row" onDragOver={stopDnD} onDrop={stopDnD}>
        <div className="col-xs-8 form-horizontal">
          {uploadFailedElement}

          <div className="form-group required m-xs-b-lg">
            <DirectToCloudDropzone {...this.directToCloudDropzoneProps()} />
          </div>

          {this.nameFormGroup(this.requests.uploadImage)}

          <div className="form-group row">
            <div className="col-xs-9 col-xs-offset-3">
              <button disabled={!this.state.imageUrl || this.state.uploading || this.state.nameIsInvalid} className="btn btn-primary btn-block btn-lg" onClick={this.handleUploadClicked}>
                Upload Image <i className="ficon ficon-check-circle p-xs-l-xs"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="col-xs-4 p-xs-l-xl">
          <div className="alert alert-info bg-body">
            <p className="m-xs-b-0 text-sm">
              Fort Awesome can process, serve, and optimize <strong>JPGs, PNGs, and SVGs</strong> formatted image files.
            </p>
          </div>

          <div className="alert alert-primary bg-body text-sm m-xs-y-md">
            <h3 className="text-base">Need help?</h3>
            <hr className="m-xs-t-sm m-xs-b-md" />
            <ul className="p-xs-l-md">
              <li>
                <a href="/help#qa-images-format">What image types and sizes do you support?</a>
              </li>
              <li>
                <a href="/help#qa-images-how">How does Fort Awesome optimize images?</a>
              </li>
              <li>
                <a href="/help#qa-images-views">Do live images count as pageviews?</a>
              </li>
            </ul>
          </div>

          <div className="alert alert-primary bg-body">
            <h3 className="text-base">Not sure where to find images?</h3>
            <hr className="m-xs-t-sm m-xs-b-md" />
            <p className="m-xs-b-0 text-sm">
              We recommend <a href="https://unsplash.com">Unsplash</a>, <a href="https://picjumbo.com/">picjumbo</a>, and <a href="http://www.gratisography.com/">Gratisography</a>.
            </p>
          </div>
        </div>
      </div>
    );
  },
});

export default connect(mapStateToProps)(UploadImageForm);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/UploadImageForm.js